import React from 'react'
import MuiTable from '../../../../../Forms/SharedComponents/containers/MuiTable'
import { TABLA_CAMIONES_SIN_CUPO } from '../../../../../../config/tables'

function TablaCamionesSinCupoView () {
  return <MuiTable id={TABLA_CAMIONES_SIN_CUPO} />
}

export default TablaCamionesSinCupoView
